import { Grid, TextField } from '@material-ui/core';
import moment from 'moment';
import React, { FC } from 'react';
import Ticket from 'src/interfaces/api/Ticket';
import { createUseStyles } from 'src/theming';
import Card from 'src/components/Card';
import Timer from '../Timer/Timer.container';
import PlanningAction from '../PlanningAction/PlanningAction.container';
import EditableTextField from '../../scenes/DetailsCard/components/EditableTextField';
import CardTitle from 'src/components/CardTitle';

interface Props {
  ticket: Ticket;
  onUpdateField: <T extends keyof Ticket>(fieldName: T, newValue: Ticket[T]) => void;
}

const useStyles = createUseStyles((theme) => ({
  subtitle: {
    fontWeight: 'bold !important',
    lineHeight: '17px !important',
  },
  noUppercase: {
    textTransform: 'none !important',
  },
  noOverflow: {
    lineHeight: '17px !important',
    wordWrap: 'break-word',
  },
  title: {
    marginBottom: '20px !important',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  dunning: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
}));

const GeneralInformationsCard: FC<Props> = ({ ticket, onUpdateField }) => {
  const classes = useStyles();

  return (
    <Card>
      <CardTitle title='Informations générales' />

      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.column}>
          <EditableTextField
            label='Sujet'
            onSave={(value) => value && onUpdateField('subject', value)}
            defaultValue={ticket.subject}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} className={classes.column}>
          <Timer ticketId={ticket.id} />
        </Grid>

        <Grid item xs={12} className={classes.column}>
          <TextField
            variant='outlined'
            label="Date d'ouverture"
            value={moment(ticket.createdAt).format('DD-MM-YY à HH:mm')}
            InputProps={{ readOnly: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} className={classes.column}>
          <TextField
            variant='outlined'
            label='Dernière modification'
            value={ticket.dateLastUpdate ? moment(ticket.dateLastUpdate).format('DD-MM-YY à HH:mm') : '---'}
            InputProps={{ readOnly: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} className={classes.column}>
          <PlanningAction ticketId={ticket.id} />
        </Grid>
      </Grid>
    </Card>
  );
};

export default GeneralInformationsCard;
